package com.arena_web.data.dto

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonObject

@Serializable
data class SportProfileDto(
    val id: String,
    val userId: String,
    val sportId: String,
    val overallRating: Double,
    val position: SportPositionDto? = null,
    val club: String? = null,
    val country: String? = null,
    val ratings: List<SportProfileRatingDto>,
    val stats: SportProfileStatsDto? = null,
    val createdAt: String,
    val updatedAt: String
)

@Serializable
data class SportProfileRatingDto(
    val attribute: SportAttributeDto,
    val value: Double,
    val totalReviews: Int
)

@Serializable
data class SportProfileStatsDto(
    val matchesPlayed: Int,
    val wins: Int,
    val losses: Int,
    val draws: Int,
    val details: JsonObject
)

@Serializable
data class UpdateSportProfileRequest(
    val positionId: String? = null,
    val club: String? = null,
    val country: String? = null
)

/** Cross-sport "All" payload — mean of `overallRating` across every sport
 *  the user has been rated in (1.00–5.00). `sportsRated == 0` means
 *  nobody has voted on this user in any sport yet. */
@Serializable
data class SportProfileAggregateDto(
    val overallRating: Double,
    val sportsRated: Int,
)

